/* eslint-disable brace-style */
import Discovery from './classes/Discovery';
import SearchResults from './components/views/SearchResults.vue';
import TestView from './components/entries/TestView.vue';
import BibSearch from './components/entries/BibSearch.vue';
import HoverCover from './components/entries/HoverCover.vue';
import Recommendation from './components/entries/Recommendation.vue';

Discovery.components = {
  TestView,
  SearchResults,
  BibSearch,
  HoverCover,
  Recommendation,
};

// Set globals
globalThis.Discovery = Discovery;
